// eslint-disable-next-line no-unused-vars
const analyticsTypes = require('../jsdoc-types');
const { analyticsEventCenter } = require('../events');
const { searchDataStorage, searchDataOfCartItemsStorage } = require('../stores/searchData');
const { getPidWithoutSize } = require('../../common/helpers/productIdHelpers');

/**
 * Handle search data from search event
 * Get search data from localStorage or asign an empty array
 * If product already exists in stored searchData, update info
 * If product does not exist in stored searchData, create object
 * Set searchData in localStorage
 * @param {Object} data search data from event
 * @param {Object[]} data.products array of products results from search
 * @param {Object} data.search search data from event
 * @param {number} data.search.count search count
 * @param {boolean} data.search.isCached search is cached
 * @param {string} data.search.match search match
 * @param {number} data.search.page search page
 * @param {string} data.search.query search query
 */
function trackSearchData(data) {
  const products = data?.products ?? [];
  if (products.length === 0) return;

  products.forEach((product) => {
    const productID = product.product.id;
    const {
      count, match, query,
    } = data.search;
    searchDataStorage.setItem(productID, {
      count, match, query,
    });
  });
}

/**
 * Track the search data of a product when it has been added to cart
 * @param {Object} payload The event payload
 * @param {FullProduct} payload.product The full product data
 * @param {analyticsTypes.SearchDataOfProduct} payload.searchData Search data
 */
function trackCartSearchData({ product, searchData }) {
  searchDataOfCartItemsStorage.setItem(product.id, searchData); // variant
  searchDataOfCartItemsStorage.setItem(getPidWithoutSize(product.id), searchData); // variation group
}

/**
 * Begin the tracking for gaInfo related data
 */
function beginTracking() {
  analyticsEventCenter.subscribe(
    analyticsEventCenter.EVENTS.searchReturnedResults,
    trackSearchData,
  );
  analyticsEventCenter.subscribe(
    analyticsEventCenter.EVENTS.productAddedToCart,
    trackCartSearchData,
  );
}

module.exports = {
  beginTracking,
};
